import React, { useEffect } from "react";
import { Image, ModalProps } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import "./CancelGameModal.scss";
import GhostButton from "../../dashboard-page/GhostButton/GhostButton";
import FilledButton, {
  ButtonSizes,
} from "../../dashboard-page/FilledButton/FilledButton";
import CloseRoundedIcon from "../../icons/CloseRoundedIcon";
import useCancelTournamentEntryMutation from "../../../react-query/mutations/use-cancel-tournament-entry";
import { CustomSpinner } from "../../CustomSpinner/CustomSpinner";
import BottomDrawer from "../../BottomDrawer/BottomDrawer";
import useAnalytics from "../../../hooks/useAnalytics";
import { Tournament } from "@nestcoinco/hyper-api-gateway-api-client";
import { TOURNAMENT_TO_GAME_TYPE_MAP } from "../../../utils/constants";

interface CancelGameModalProps extends Pick<ModalProps, "show"> {
  redirectUrl?: string;
  entryId: string;
  tournamentDetails?: Tournament;
  onHide: () => void;
}
function CancelGameModal({
  show,
  onHide,
  redirectUrl,
  entryId,
  tournamentDetails,
}: CancelGameModalProps) {
  const { game, stakeAmount, type } = tournamentDetails ?? {};
  const {
    cancelEntry,
    mutation: { isPending, isSuccess },
  } = useCancelTournamentEntryMutation({
    entryId,
    redirectUrl,
  });
  const { t } = useTranslation("games");
  const analytics = useAnalytics();

  useEffect(() => {
    if (!isSuccess || !stakeAmount || !game || !type) return;
    analytics.sendCancelGameEvent({
      entry_fee: stakeAmount,
      game_name: game.name,
      game_mode: TOURNAMENT_TO_GAME_TYPE_MAP[type],
    });
  }, [isSuccess, analytics, stakeAmount, game, type]);

  return (
    <BottomDrawer onClose={onHide} isOpen={!!show}>
      <div className="cancel-game-modal">
        <div>
          <div className="img-box">
            <Image src={game?.thumbnail} alt="" height={50} width={50} />
            <CloseRoundedIcon className="cancel-icon" />
          </div>
          <h2 className="heading">{t("cancel_game_modal.cancel_game")}</h2>
          <p className="content">{t("cancel_game_modal.sure")}</p>
          <FilledButton
            fullwidth
            size={ButtonSizes.MD}
            className="mb-1"
            onClick={onHide}
          >
            {t("cancel_game_modal.continue")}
          </FilledButton>
          <GhostButton
            className="cancel-btn"
            onClick={cancelEntry}
            disabled={isPending}
          >
            {t("cancel_game_modal.cancel")}{" "}
            {isPending && (
              <CustomSpinner size="sm" className="ms-1" isPrimary />
            )}
          </GhostButton>
        </div>
      </div>
    </BottomDrawer>
  );
}

export default CancelGameModal;
